export default function mapProfileData(data) {
  if (data) {
    return {
      levelNumber: data.level?.levelNumber || 0,
      levelName: data.level?.levelName?.currentLevelName,
      currentLevelNumber: data.level?.levelName?.currentLevelSublevel || '',
      displayName: data.displayName,
      percentage: data?.level?.currentLevelPct || 0,
    };
  }
  return {};
}
